module.exports = __webpack_public_path__ + "static/media/8OLA24.a1424b4a.jpg";